import { FC, useEffect, useState } from "react";
import { useAppSelector } from "store/services";
import { Button, Col, Divider, Form, Input, message, Modal, Row } from "antd";
import instance from "config/_axios";
import { asyncN } from "utils/notifications";
import { useHistory } from "react-router-dom";

const ChangePassword: FC<{ id: number, visible: boolean, setVisible: (visible: boolean) => void }> = ({ id, visible, setVisible }): JSX.Element => {

  const [form] = Form.useForm();

  const onSubmit = async (values: any) => {
    try {
      const formdata = new FormData();
      Object.entries(values).forEach(([key, value]: any) => {
        formdata.append(key, String(value));
      });

      const response = await instance({ url: `/passwords/${id}`, method: 'PUT', data: formdata })

      if (response.data.status === 1) {
        form.resetFields();
        message.success("Parol muvaffaqiyatli o'rgartirildi");
        setVisible(false);
      }
    } catch (error: any) {
      asyncN("error", 'update', error?.response.data?.message);
    }
  }

  return (
    <Modal title="Parolni o'zgartirish" visible={visible} onCancel={() => setVisible(false)} footer={false} >
      <Form
        layout="vertical"
        form={form}
        onFinish={onSubmit}
      >
        <Form.Item
          label="Avvalgi parol"
          name='old_password'
          rules={[{ required: true, message: "Maydonni to'ldirish shart!" }]}
        >
          <Input.Password placeholder="Avvalgi parolingizni kiriting ..." />
        </Form.Item>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Yangi parol"
              name='new_password'
              rules={[{ required: true, message: "Maydonni to'ldirish shart!" }]}
            >
              <Input.Password placeholder="Yangi parolni kiriting ..." />
            </Form.Item>

          </Col>
          <Col span={24}>
            <Form.Item
              label="Parolni takrorlang"
              name='re_password'
              rules={[{ required: true, message: "Maydonni to'ldirish shart!" }]}
            >
              <Input.Password placeholder="Parolni qayta kiriting ..." />
            </Form.Item>

          </Col>
        </Row>
        <Divider className="mt-5" />
        <div className="text-end" >
          <Button type="primary" danger onClick={() => { form.resetFields(); setVisible(false) }}>Bekor qilish</Button>
          <Button className="ms-2" htmlType="submit" type="primary">Saqlash</Button>
        </div>
      </Form>
    </Modal>
  )
}

export default ChangePassword;